import * as Sentry from '@sentry/react';

/**
 * Client-side error monitoring (Sentry).
 *
 * Activated ONLY when REACT_APP_SENTRY_DSN is set at BUILD time (baked into the
 * bundle by the Docker frontend stage) — a no-op otherwise, so dev and an
 * un-configured build are untouched. The frontend DSN is not a secret (it only
 * permits sending events), so it is supplied as a Docker build-arg.
 *
 * PII-SAFE BY CONSTRUCTION — we handle real families' (incl. children's) data:
 *   - sendDefaultPii: false (no client IP / user identity)
 *   - NO Session Replay integration (replay records the DOM = member/child PII)
 *   - beforeSend strips request body / cookies / auth / query string / user
 *   - errors only (no performance tracing)
 * See MONITORING_SETUP.md.
 */
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_VERSION || undefined,
    sendDefaultPii: false,
    // Deliberately NO replayIntegration() — it would record the DOM (PII). The
    // default integrations (global error + unhandledrejection handlers,
    // breadcrumbs) stay on so errors are still captured.
    tracesSampleRate: 0,
    beforeSend(event) {
      // Belt-and-suspenders: never let request bodies / auth / identity leave the browser.
      const req = event.request as any;
      if (req) {
        delete req.data;
        delete req.cookies;
        delete req.query_string;
        if (req.headers) {
          delete req.headers['Authorization'];
          delete req.headers['Cookie'];
        }
      }
      delete (event as any).user;
      return event;
    },
  });
}
